import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {VeranstaltungenInfoKategorienPage} from './veranstaltungen-info-kategorien.page';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {reducers} from './veranstaltungen-info-kategorien.reducer';
import {VeranstaltungenInfoKategorienPageUiEffects} from './veranstaltungen-info-kategorien.effects.ui';
import {
    VeranstaltungenVeranstaltungInfoKategorieEntfernenEffects,
    VeranstaltungenVeranstaltungInfoKategorieErfassenEffects,
    VeranstaltungenVeranstaltungInfoKategorieReihenfolgeSetzenEffects,
} from '../../../../client-ngrx/veranstaltungen';
import { EffectsWs } from './veranstaltungen-info-kategorien.effects.ws';
import {MarkdownModule} from 'ngx-markdown';
import {PipesModule} from '../../../../sopi/pipes/pipes.module';
import {VeranstaltungenVeranstaltungInfoKategorienAdminEffects} from '../../../../client-ngrx/veranstaltungen';
import {SopiComponentsModule} from '../../../shared/sopi-components/sopi-components.module';
import {SopiDirectivesModule} from '../../../../sopi/directives/sopi-directives.module';
import {SopiScrollModule} from '../../../../sopi/components/sopi-scroll/sopi-scroll.module';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        // RouterModule.forChild(routes),

        MarkdownModule.forChild(),

        StoreModule.forFeature('VeranstaltungenInfoKategorienPage', reducers),
        EffectsModule.forFeature([
            VeranstaltungenInfoKategorienPageUiEffects,
            EffectsWs,
            /* VERANSTALTUNGEN */
            // GET
            VeranstaltungenVeranstaltungInfoKategorienAdminEffects,

            // POST
            VeranstaltungenVeranstaltungInfoKategorieEntfernenEffects,
            VeranstaltungenVeranstaltungInfoKategorieErfassenEffects,
            VeranstaltungenVeranstaltungInfoKategorieReihenfolgeSetzenEffects,
        ]),
        SopiComponentsModule.forRoot(),
        SopiDirectivesModule.forRoot(),
        SopiScrollModule,
        PipesModule
    ]
})

export class VeranstaltungenInfoKategorienPageModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: VeranstaltungenInfoKategorienPageModule,
        };
    }
}
